/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueCookie from 'vue-cookie';
import router from './routes.js';
import _ from 'lodash';
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';
import store from './store';
import Promise from 'bluebird';
import VueI18n from 'vue-i18n';
import LokaliseFormatter from './classes/LokaliseFormatter';
import VSwitch from 'v-switch-case'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Clipboard from 'v-clipboard';
import VueApexCharts from 'vue-apexcharts';
import VeeValidate from 'vee-validate';
window.Vue = Vue;
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

let lang = process.env.MIX_APP_LANG;
const files = require.context('./', true, /\.vue$/i);
const version = require('./../../version.json');
function lazyLoad(component) {
    return () => import('' + component + '');
}
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], lazyLoad(key)));

Vue.component('apexchart', VueApexCharts);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(VueRouter);
Vue.use(VueCookie);
Vue.set(Vue.prototype, '_', _);
Vue.set(Vue.prototype, 'Promise', Promise);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueI18n);
Vue.use(VSwitch);
Vue.use(Loading, {global: true, name: 'loading'});
Vue.use(Clipboard);

Vue.use(VeeValidate, {
    inject: true,
    fieldsBagName: "veeFields",
    errorBagName: "veeErrors"
});

Vue.component('loading', Loading);

window._store = store;

store.subscribeAction((action, state) => {
    switch (action.type) {
        case 'auth/logoutSuccess':
            return router.push({name: 'login'});
        case 'auth/loginSuccess':
            let backRoute = _.clone(store.getters['auth/backRoute']);
            store.commit('auth/forgetBackRoute');

            return router.push((backRoute && backRoute.name && backRoute.name !== 'login') ? backRoute : {name: 'tests_active'});
    }
});

Vue.filter('price', value => {
    if ((value % 1) > 0) {
        return parseFloat(value).toFixed(2);
    }
    return parseInt(value).toFixed(2);
});

window._router = router;

function loadLang(cb) {
    function readTextFile(file, callback) {
        let rawFile = new XMLHttpRequest();
        rawFile.overrideMimeType("application/json");
        rawFile.open("GET", file, true);
        rawFile.onreadystatechange = function () {
            if (rawFile.readyState === 4 && rawFile.status == "200") {
                callback(rawFile.responseText);
            }
        };
        rawFile.send(null);
    }

    readTextFile('/js/lang.json?ver=' + new Date().getTime(), function (text) {
        const Messages = JSON.parse(text);
        cb(Messages);
    });
}

function launch(messages) {
    // Deleting default languages
    delete messages['vendor'];
    // delete messages['default'];
    // Create VueI18n instance with options
    const i18n = new VueI18n({
        locale: lang,
        fallbackLocale: 'default',
        messages,
        formatter: new LokaliseFormatter()
    });

    // Create Vue instance with options
    const app = new Vue({
        el: '#app',
        store,
        mounted() {
            let preloader = document.getElementById('preloader'),
                hidden = document.getElementsByClassName('hidden');
            if (preloader) {
                preloader.remove();
            }

            Array.from(hidden).forEach((item) => {
                item.classList.remove('hidden');
            });
        },
        created() {
            lang = this.$cookie.get('lang') || process.env.MIX_APP_LANG;
            this.setLang(lang);
        },
        data() {
            return {
                lang: lang,
                languages: Object.keys(messages).filter(l => l !== 'default'),
                lokaliseAccess: false,
                appName: process.env.MIX_APP_NAME,
                stripePublicKey: process.env.MIX_STRIPE_KEY,
                currencyLabel: process.env.MIX_CURRENCY_LABEL,
                globalNotification: {
                    type: null,
                    message: null
                },
                version
            }
        },
        router,
        i18n,
        computed: {
            isLoading() {
                return this.$store.getters['isLoading'];
            }
        },
        methods: {
            setLang(lang) {
                this.$i18n.locale = lang;
                this.$cookie.set('lang', lang, {
                    expires: '1M'
                });
                this.lang = lang;
            }
        }
    });
}

loadLang(launch);
